module.exports = __webpack_public_path__ + "img/parenting.e3af7d7a.svg";